import { styled } from "@mui/material";
import { DatePicker } from "@volt_developers/components";

export const CreatedByFilter = styled(DatePicker.RangePicker)({
  minWidth: "200px",
});
